import React from 'react';

function Productpage() {
  return (
    <div>
      {/* Hero Image */}
      <section>
        <img
          className="d-block w-100"
          src="https://www.webhopers.com/wp-content/uploads/2020/02/Web-Development-Web-Designing-Company-in-Manimajra.jpg"
          alt="Web Development and Designing"
        />
      </section>

      {/* Content Section */}
      <section className="container mt-4">
        <div className="row">
          {/* Left Text Column */}
          <div className="col-lg-8 block-1 text-start">
            <div className="common-heading text-l">
              <h2>Creative Web Design & Development Service</h2>
              <p className="justify-text">
                N D Techland offers a unified suite of cloud-native solutions that streamline
                every aspect of your operations: N D Connect brings together HR, finance,
                operations and analytics with GPS-verified attendance, dynamic invoicing,
                automated payroll and AMC tracking accessible via web and mobile; our Cab
                Rental App handles staff transportation from intelligent booking and live GPS
                tracking to OTP-secured pickups, route optimization and automated billing; the
                Health Care App delivers a complete digital health ecosystem—patient bookings,
                e-prescriptions, OPD/IPD workflows, pharmacy and lab integration, ambulance
                dispatch and real-time reporting; Municipal Corporation Software automates
                property-tax and utility billing with online payments, SMS/WhatsApp/voice
                notifications and customizable printing; the TimeShare Management Solution
                manages memberships, AMC/EMI schedules, online bookings, member and agent
                apps, multi-role portals and performance analytics;
              </p>
              <p className="justify-text">
                PMS® ERP for FMCG Wholesale provides real-time inventory control, procurement
                planning, bulk dispatch, AR/AP, GST compliance, commission processing, barcode
                support and over 700 reports; Hospital Management Software (LHMS) integrates
                clinical, administrative and financial workflows including patient portals,
                scheduling, billing, pharmacy/lab modules and secure reporting; our Transport
                Management Application automates logistics with order booking, fleet/carrier
                management, route planning, dispatch, live tracking, legacy-style print
                customization and flexible deployment; and finally, our Multi-Level Marketing
                Software supports downline genealogy, automated multi-plan commissions,
                e-pin/e-wallet management, self-service portals and integrated order/inventory
                management—all modular, secure and scalable to accelerate growth.
              </p>
            </div>
          </div>
          {/* Right Image Column */}
          <div className="col-lg-4 d-flex align-items-start justify-content-end">
            <div
              className="image-block upset bg-shape wow fadeIn"
              style={{ width: "100%", textAlign: "right" }}
            >
              <img
                src="https://www.shutterstock.com/image-photo/digital-marketing-commerce-online-sale-600nw-2269149669.jpg"
                alt="Web Service"
                className="img-fluid"
                style={{
                  height: "500px",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </div>
          </div>
          <section className="service-block bg-gradient6 pad-tb light-dark">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-6">
                  <div className="common-heading ptag text-center">

                    <h2>N D Techland Core Values</h2>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      We think big and have hands in all leading technology platforms to provide you wide array of services.
                    </p>

                  </div>
                </div>
              </div>
              <div className="row upset link-hover">
                {/* Card 1 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay=".2s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="images/icons/logo-and-branding.svg" alt="service" className="img-fluid" />
                    </div>
                    <h4>N D Connect</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      A cloud-based ERP that unifies HR, finance, and operations—offering GPS-validated attendance, shift
                      planning, dynamic invoicing, payroll automation, AMC tracking, and real-time analytics accessible via web
                      and mobile.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files/NDTechland_MCS_Software_Presentation.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>

                  </div>
                </div>

                {/* Card 2 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay=".4s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="images/icons/service2.svg" alt="service" className="img-fluid" />
                    </div>
                    <h4>Cab Rental App</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      An end-to-end staff transportation solution with driver/vehicle management, intelligent ride booking, live
                      GPS tracking, OTP-secured pickups, optimized routing, automated billing, and dedicated rider/driver mobile
                      apps.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files//Corporate-Cab-Services.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay=".6s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="images/icons/service3.svg" alt="service" className="img-fluid" />
                    </div>
                    <h4>Health Care App</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      A full-spectrum digital health platform connecting patients, clinicians, hospitals, pharmacies, labs, and
                      ambulances—featuring appointment booking, e-prescriptions, OPD/IPD management, inventory control,
                      teleconsultations, and centralized reporting.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="files/Complete-Health-Care-App%20nEW.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>
                {/* Card 4 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay=".8s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="images/icons/service4.svg" alt="service" className="img-fluid" />
                    </div>
                    <h4>Municipal Corporation Software</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      A civic-services suite for property-tax and utility management: property databases, auto assessments &
                      billing, secure online payments, SMS/WhatsApp/voice alerts, multi-format printing, and native mobile access
                      for citizens and administrators.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files/NDTechland_MCS_Software_Presentation.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>

                {/* Card 5 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay="1s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="images/icons/service6.svg" alt="service" className="img-fluid" />
                    </div>
                    <h4>TimeShare Management Solution</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      A vacation-club platform managing memberships, AMCs/EMIs, online bookings & payments, member & agent apps,
                      multi-role web portals (admin, marketing, accounts), CRM-driven lead management, and comprehensive
                      performance reporting.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files/Timeshare-CRM-with-Mobile-App.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>

                {/* Card 6 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay="1.2s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="https://cdn-icons-png.freepik.com/256/17230/17230355.png?semt=ais_white_label" alt="service" className="img-fluid" />
                    </div>
                    <h4>PMS® ERP for FMCG Wholesale</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      A cloud ERP for FMCG distribution: real-time stock tracking (lot/serial), procurement planning, bulk
                      dispatch, AR/AP, GST compliance, commission & cash-receipt handling, barcode support, SMS alerts, and 700+
                      drill-down reports.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files/PMSr-ERP-Software-for-FMCG-Wholesale.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>

                {/* Card 7 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay="1.4s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="https://cdn-icons-png.freepik.com/256/17663/17663246.png?semt=ais_white_label" alt="service" className="img-fluid" />
                    </div>
                    <h4>Multi-Level Marketing Software</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      A cloud MLM system featuring downline genealogy, automated commission plans (unilevel, binary, matrix),
                      e-pin/e-wallet management, self-service member portals, admin dashboards, integrated order/inventory, and
                      secure, scalable architecture.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files/MLM-Software-Solutions.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>
                {/* Card 8 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay="1.6s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWG-VLirTvhttt3CNgTMDTpo1I9mbnL5l5Oo1R98csnCfJSiLNmJ2dNpaOAXWdDW_HGuk&usqp=CAU" alt="service" className="img-fluid" />
                    </div>
                    <h4>Hospital Management Software (LHMS)</h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      An integrated HIS for clinical, administrative, and financial workflows—patient portals, OPD/IPD
                      scheduling, bed/billing management, lab & pharmacy modules, ambulance dispatch, and exportable PDF/Word/Excel
                      reports with role-based security.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files/LHMS-Local-Hospital-Management-Software.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>

                {/* Card 9 */}
                <div className="col-lg-4 col-sm-6 mt30 wow fadeInUp" data-wow-delay="1.8s">
                  <div className="s-block h-100 d-flex flex-column">
                    <div className="s-card-icon">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzlIszfkyw_zMxsEIzLz-C-jWictMFgXveVmC-zgUP1XyMx3MAwJP_45DldLQ4yVfwUIs&usqp=CAU" alt="service" className="img-fluid" />
                    </div>
                    <h4>Transport Management  Application </h4>
                    <p className="mb30" style={{ textAlign: "justify" }}>
                      A SaaS logistics platform for order booking, fleet/carrier management, route optimization, dispatch, live
                      GPS tracking, DOS-style customizable printing, robust access controls, and flexible multi-tenant or
                      on-premise deployment options.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                      <a
                        href="/files/NDTechland_MCS_Software_Presentation.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "rgb(0, 51, 102)",
                          color: "rgb(255, 255, 255)",
                          border: "1px solid rgb(0, 51, 102)",
                          padding: "6px 16px",
                          borderRadius: "5px",
                          fontWeight: 500,
                          transition: "0.3s"
                        }}
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  );
}

export default Productpage;
